import axios from 'axios';

class OrderService {
    async getActiveOrders() {
        return axios.post('order/active', {});
    }

    async deleteOrder(orderId) {
        return axios.delete(`order/${orderId}`);
    }

    async deleteOrderDetail(orderId) {
        return axios.delete(`order-detail/order/${orderId}`);
    }

    async getAutomaticOrders() {
        return axios.post('order/automatic-orders');
    }

    async viewAutomaticOrder(orderId) {
        return axios.get(`order/view-automatic-orders/${orderId}`);
    }

    async acceptAutomaticOrder(orderIds) {
        return axios.post('order/accept-automatic-orders', {
            order_ids: orderIds,
        });
    }

    async deleteAutomatedOrders(orderIds) {
        return axios.post('order/delete-automatic-orders', {
            order_ids: orderIds,
        });
    }

    async reRunAutomatedOrders(){
        return axios.post('/order/run-automatic-orders', {})    
    }

    async updateAutomatedOrderProducts(params){
        return axios.post('automatic-order/update-order-details', params)    
    }

    async getActivityLogForModifiedAutomatedOrder(orderId){
        return axios.get(`/automatic-order/automatic-order-activity/${orderId}`)
    }
}

export default new OrderService();
